import React, { useState, useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermAndContions from "./pages/TermAndContions";
import EditProfile from "./pages/EditProfile";
import Address from "./pages/Address";
import { useDispatch, useSelector } from 'react-redux';
import Faq from './pages/Faq';
import MyProfile from './pages/MyProfile';
import Blog from './pages/Blog';
import SingleBlog from './pages/SingleBlog';
import Courses from './pages/Courses';
import Events from './pages/Events';
import EventsSinglePage from './pages/EventsSinglePage';
import CourseSinglePage from './pages/CourseSinglePage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);  // 2s delay for simulation
  }, []);

  return (
    <BrowserRouter>
    <ScrollToTop />
      {loading ? (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="faqs" element={<Faq />} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="term-conditions" element={<TermAndContions />} />
            <Route path="edit-profile" element={<EditProfile />} />
            <Route path="address" element={<Address />} />
            <Route path="blogs" element={<Blog />} />
            <Route path="blog/:id" element={<SingleBlog />} />
            <Route path="courses" element={<Courses />} />
            <Route path="course/:id" element={<CourseSinglePage />} />

            <Route path="events" element={<Events />} />
            <Route path="event/:id" element={<EventsSinglePage />} />

          </Route>
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;
